// extracted by mini-css-extract-plugin
module.exports = {"socials":"override-module--socials--2SlsZ","blog":"override-module--blog--3r9U4","blog__navegation":"override-module--blog__navegation--3f04o"};